/* @todo: remove TextWithFeatureImage once integrated with contentful */

import React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'
import Container from '../../Container'
import { Content } from './PageContent.style'
import { PrimaryButton, ButtonArrow } from '../../../shared/Buttons/Buttons.styles'
import ArrowRight from '../Icons/ArrowRight'

const PageContent = ({ buttonText, buttonLink, content: { childMarkdownRemark: { html } } }) => (
  <Container>
    <Content
      className="wow fadeIn"
      data-wow-delay="0.3s"
      dangerouslySetInnerHTML={{
        __html: html,
      }}
    />
    { buttonText && buttonLink && (
      <PrimaryButton center>
        <a href={buttonLink} aria-label={buttonText}>
          {buttonText}
          <ButtonArrow viewBox="0 0 12 21"><ArrowRight /></ButtonArrow>
        </a>
      </PrimaryButton>
    )}
  </Container>
)

PageContent.propTypes = {
  content: PropTypes.shape({
    childMarkdownRemark: PropTypes.shape({
      html: PropTypes.string,
    }),
  }).isRequired,
  buttonText: PropTypes.string,
  buttonLink: PropTypes.string,
}

PageContent.defaultProps = {
  buttonText: '',
  buttonLink: '',
}

export default PageContent

export const PageContentFragment = graphql`
  fragment PageContentFragment on ContentfulGenericPageContent {
    id
    title
    content {
      childMarkdownRemark {
        html
      }
    }
    buttonText
    buttonLink
  }
`
